import React, {Component} from 'react'

import {Link} from 'react-router-dom'

import {
  Button,
  CardActions,
} from 'material-ui'

export default class JobCardActions extends Component{
  render(){
    const {actions} = this.props;
    return (
      <CardActions className='cardActions' >
        {!!actions && actions.map(action=>{
          if(!!action.link){
            return (
              <Link key={`${action.text}_link_${action.link}`} to={action.link}>
                <Button className='cardActionsBtn' color={action.color} onClick={action.click} raised={action.raised} >
                  {action.text}
                </Button>
              </Link>
            )
          }
          else{
            return (
              <Button key={`${action.text}_btn}`} className='cardActionsBtn' color={action.color} onClick={action.click} raised={action.raised} >
                {action.text}
              </Button>
            )
          }
        })}
      </CardActions>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/JobCardActions.js